import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './locale-timezone.module.css';
import { Button, Text } from '@mantine/core';
import { useLocaleTimeZone } from '@/containers/pages/filials/edit/components/tabs/locale-timezone/useLocaleTimeZone';
import { LanguageSelect } from '@components/language-select';
import TimezoneSelect from '@components/TImezoneSelect';

const LocaleTimezonePage: FC = () => {
  const { t } = useTranslation();
  const { form, isLoading, handleSave } = useLocaleTimeZone();

  return (
    <div className={classes.wrapper}>
      <Text className={classes.mainTitle}>{t('filials.settings.localePageTitle')}</Text>
      <Text className={classes.subTitle}>{t('filials.settings.localeLanguageLabel')}</Text>
      <div>
        <Text className={classes.title}>{t('filials.settings.localeLanguageTitle')}</Text>
        <LanguageSelect
          label=""
          value={form.getInputProps('locale').value}
          {...form.getInputProps('locale')}
        />
      </div>
      <div>
        <Text className={classes.title}>{t('filials.settings.localeTimezoneTitle')}</Text>
        <TimezoneSelect
          label=""
          value={form.getInputProps('timezone').value}
          {...form.getInputProps('timezone')}
        />
      </div>
      <Button loading={isLoading} onClick={handleSave}>
        {t('save')}
      </Button>
    </div>
  );
};

export default LocaleTimezonePage;
